<div class="flex mt-2 mb-2 px-4 md:px-0 w-full">
  <div class="bg-white/50 backdrop-blur-sm rounded-[10.4px] p-4 shadow-sm border border-white overflow-hidden
           w-full md:inline-block md:w-auto md:max-w-2xl">

    <div class="flex items-start gap-3" [ngClass]="contentItems.length ? 'mb-4' : 'mb-0'">
      <div class="block sm:hidden w-6 h-6 bg-gray-900 rounded-full flex items-center justify-center flex-shrink-0 mt-1">
        <app-ivy-face></app-ivy-face>
      </div>
      <p class="text-sm font-medium text-gray-900">
        {{ data.message }}
      </p>
    </div>

    <div class="relative w-full h-32 bg-transparent" *ngIf="showLoader && !this.contentItems.length">
      <div class="absolute inset-0 flex items-center justify-center bg-transparent">
        <div class="w-6 h-6 border-2 border-white-300 border-t-purple-500 rounded-full animate-spin"></div>
      </div>
    </div>

    <div class="space-y-3">

      <div class="inline-grid w-auto grid-cols-2 md:grid-cols-4 gap-4 justify-start align-middle">
        @for (content of contentItems; track content; let i = $index; let last = $last) {
        @if (content) {
        <div (click)="onContentItemClick(content)"
          class="group relative overflow-hidden rounded-[10px] cursor-pointer transition-all shadow-sm hover:shadow-md bg-gray-100"
          [ngClass]="(last && ((data.answer.options?.length || 0) % 2 !== 0))
              ? 'col-span-2 md:col-span-4 w-full md:w-4/5 aspect-video md:min-w-[350px]'
              : 'aspect-[4/5] min-w-[100px]'">

          @if (content && content?.url_thumb) {
          <img [src]="content?.url_thumb" [attr.alt]="content?.title || ''"
            class="h-full w-full object-cover object-center rounded-[10px] aspect-video" />
          } @else {
          <img [src]="thumbPath + content?.image" [attr.alt]="content?.title || ''"
            class="h-full w-full object-cover object-center rounded-[10px]" />
          }

          <div *ngIf="capitalizeFirstLetter(content?.activity_type ?? '') != ''"
            class="absolute top-1 right-2 z-30 pointer-events-none">
            <span
              class="inline-flex items-center px-1 py-1 rounded-[3px] text-white text-[10px] font-semibold leading-none"
              style="
                  background: linear-gradient(0deg, rgba(19, 0, 38, 0.2), rgba(19, 0, 38, 0.2)),
                              linear-gradient(0deg, rgba(255, 255, 255, 0.1), rgba(255, 255, 255, 0.1));
                  border: 1px solid #FFFFFFB2;
                  backdrop-filter: blur(8px);
                  -webkit-backdrop-filter: blur(8px);
                ">
              {{ capitalizeFirstLetter(content?.activity_type ?? '') }}
            </span>
          </div>

          <div class="pointer-events-none absolute inset-x-0 bottom-0 h-20 rounded-b-xl"
            style="background: linear-gradient(180deg, rgba(0, 0, 0, 0) 32.21%, #000000 134.85%);">
          </div>

          <div class="absolute bottom-2 left-2 right-2 z-10 text-white">
            <span class="block font-bold text-xs leading-tight drop-shadow-sm line-clamp-2">
              {{ content?.title }}
            </span>

            <div class="my-0.5 h-px bg-transparent"></div>

            <div
              class="inline-flex items-center gap-1.5 text-sm font-medium leading-none drop-shadow-sm whitespace-nowrap">
              <svg viewBox="0 0 12 13" class="w-[1em] h-[1em] inline-block align-middle shrink-0" aria-hidden="true"
                xmlns="http://www.w3.org/2000/svg">
                <g clip-path="url(#clip0_24322_5080)">
                  <path fill="#C389FD"
                    d="M8.80879 3.92321L9.53528 3.19671L10.2423 3.90371L9.51579 4.63021C10.2337 5.52879 10.5802 6.66815 10.4843 7.81428C10.3884 8.9604 9.85728 10.0263 9.00003 10.7931C8.14278 11.5598 7.02447 11.9693 5.87478 11.9373C4.72509 11.9052 3.63129 11.4342 2.81802 10.621C2.00475 9.8077 1.53375 8.71391 1.50174 7.56422C1.46974 6.41453 1.87916 5.29622 2.64592 4.43896C3.41269 3.58171 4.47859 3.05059 5.62472 2.95467C6.77085 2.85875 7.9102 3.20532 8.80879 3.92321ZM5.99979 10.9392C6.45941 10.9392 6.91454 10.8487 7.33918 10.6728C7.76382 10.4969 8.14965 10.2391 8.47466 9.91408C8.79966 9.58908 9.05747 9.20324 9.23336 8.7786C9.40926 8.35396 9.49979 7.89884 9.49979 7.43921C9.49979 6.97958 9.40926 6.52446 9.23336 6.09982C9.05747 5.67518 8.79966 5.28934 8.47466 4.96434C8.14965 4.63933 7.76382 4.38152 7.33918 4.20563C6.91454 4.02974 6.45941 3.93921 5.99979 3.93921C5.07153 3.93921 4.18129 4.30796 3.52491 4.96434C2.86853 5.62071 2.49979 6.51095 2.49979 7.43921C2.49979 8.36747 2.86853 9.25771 3.52491 9.91408C4.18129 10.5705 5.07153 10.9392 5.99979 10.9392ZM5.49979 4.93921H6.49979V7.93921H5.49979V4.93921ZM3.99979 1.43921H7.99979V2.43921H3.99979V1.43921Z">
                  </path>
                </g>
                <defs>
                  <clipPath id="clip0_24322_5080">
                    <rect width="12" height="12" transform="translate(0 0.939209)" />
                  </clipPath>
                </defs>
              </svg>
              <span class="align-middle text-xs">{{ toMinutes(content?.duration) }}</span>
            </div>
          </div>
        </div>
        }
        }
      </div>
    </div>
    <div *ngIf="this.contentItems.length" (click)="showMoreContent()" class="flex justify-center md:justify-start pt-4">
      <span
        class="inline-block text-[#7B4AE2] text-[12px] font-semibold underline underline-offset-2 px-2 py-1 cursor-pointer">
        Suggest more
      </span>
    </div>
  </div>
</div>